const WARNING_COPY = {
  signed_contract:
    "This job has a signed contract. The signed copy has been sent to your client.",
  unrefunded_payment: "This job has a payment that hasn't been refunded.",
  active_dispute:
    "This job has an active payment dispute. Funds may be on hold until it's resolved.",
};

const autoCancelNote = ({ unsigned_contract, unpaid_payment }) => {
  const items = [
    unsigned_contract && "unsigned contract",
    unpaid_payment && "unpaid payment request",
  ].filter(Boolean);
  if (items.length === 0) return null;
  return `Your ${items.join(" and ")} will also be cancelled.`;
};

export const deleteJobModalVariant = (preview) => {
  const warnings = (preview?.warnings || [])
    .filter((key) => WARNING_COPY[key])
    .map((key) => ({ key, message: WARNING_COPY[key] }));
  if (warnings.length > 0) return { kind: "warning", warnings };

  const note = autoCancelNote(preview?.auto_cancel || {});
  if (note) return { kind: "autoCancel", note };

  return { kind: "default" };
};
